export default __webpack_public_path__ + "static/media/table-circular-saw.1b0b810e.svg";